import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Leaf, Users, Package, CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import Hero from './home/Hero';
import StatsSection from './home/StatsSection';
import AboutSection from './home/AboutSection'; 

const watchData = [
  {
    name: "Pet Mix",
    pricePerKg: 5000,
    priceLapak: 4500,
    // image: "https://via.placeholder.com/100x100?text=Pet+Mix",
  },
  {
    name: "Pet Clear / Bening",
    pricePerKg: 3000,
    priceLapak: 2500,
    // image: "https://via.placeholder.com/100x100?text=Pet+Clear+Bening",
  },
  {
    name: "Pet BM ( Biru Muda )",
    pricePerKg: 7000,
    priceLapak: 6500,
    // image: "https://via.placeholder.com/100x100?text=Pet+BM+Biru+Muda",
  },
  {
    name: "Pet Warna",
    pricePerKg: 2300,
    priceLapak: 2500,
    image: null,
  },
  {
    name: "Pet PK",
    pricePerKg: 3000,
    priceLapak: 3100,
    image: null,
  },
  {
    name: "Pet Galon",
    pricePerKg: 3300,
    priceLapak: 3500,
    image: null,
  },
  {
    name: "Gelasan A",
    pricePerKg: 4000,
    priceLapak: 4100,
    image: null,
  },
  {
    name: "Tutup",
    pricePerKg: 1500,
    priceLapak: 1600,
    image: null,
  },
];

const Home = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [statsVisible, setStatsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setStatsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    const statsSection = document.getElementById('stats-section');
    if (statsSection) {
      observer.observe(statsSection);
    }

    return () => observer.disconnect();
  }, []);

 

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <Hero />

      {/* Stats Section */}
      <StatsSection />

      {/* About Section */}
      <AboutSection />

      {/* Vision & Mission */}
      <section
        style={{
          padding: '5rem 1.5rem',
          background: 'white'
        }}
      >
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <Card
              style={{
                background: 'white',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                borderRadius: '12px',
                padding: '2rem',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
              }}
            >
              <h3
                style={{
                  fontWeight: 600,
                  fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                  color: 'rgb(0, 55, 32)',
                  marginBottom: '1rem'
                }}
              >
                {t.vision.title}
              </h3>
              <p
                style={{
                  fontSize: '1rem',
                  lineHeight: 1.6,
                  color: 'rgb(14, 15, 12)'
                }}
              >
                {t.vision.text}
              </p>
            </Card>

            <Card
              style={{
                background: 'white',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                borderRadius: '12px',
                padding: '2rem',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
              }}
            >
              <h3
                style={{
                  fontWeight: 600,
                  fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                  color: 'rgb(0, 55, 32)',
                  marginBottom: '1rem'
                }}
              >
                {t.mission.title}
              </h3>
              <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                {t.mission.items.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      fontSize: '1rem',
                      lineHeight: 1.6,
                      color: 'rgb(14, 15, 12)',
                      marginBottom: '0.75rem',
                      display: 'flex',
                      alignItems: 'start',
                      gap: '0.5rem'
                    }}
                  >
                    <CheckCircle2
                      size={20}
                      style={{ color: '#8FEC78', marginTop: '2px', flexShrink: 0 }}
                    />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        style={{
          padding: '5rem 1.5rem',
          background:
            'radial-gradient(at 50% 50%, hsla(108,100%,50%,0.15) 0px, transparent 50%)',
          textAlign: 'center'
        }}
      >
        <div className="max-w-3xl mx-auto">
          <h2
            style={{
              fontWeight: 600,
              fontSize: 'clamp(1.875rem, 4vw, 3rem)',
              lineHeight: 0.95,
              color: 'rgb(0, 55, 32)',
              marginBottom: '1rem'
            }}
          >
            {t.cta.title}
          </h2>
          <p
            style={{
              fontSize: '1.125rem',
              lineHeight: 1.6,
              color: 'rgb(131, 146, 140)',
              marginBottom: '2rem'
            }}
          >
            {t.cta.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              className="btn-primary"
              style={{
                background: 'linear-gradient(to bottom right, #8FEC78, #81DD67)',
                color: 'white',
                borderRadius: '9999px',
                padding: '14px 32px',
                fontWeight: 600,
                fontSize: '1rem',
                minHeight: '48px'
              }}
            >
              {t.cta.btnPartner}
            </Button>
            <Button
              onClick={() => navigate('/why-us')}
              variant="outline"
              className="btn-secondary"
              style={{
                background: 'transparent',
                color: 'rgb(0, 55, 32)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                borderRadius: '9999px',
                padding: '14px 32px',
                fontWeight: 500,
                fontSize: '1rem',
                minHeight: '48px'
              }}
            >
              {t.cta.btnLearn}
            </Button>
          </div>
        </div>
      </section> <section className="w-full flex flex-col items-center justify-center pt-24 pb-8">
              <div className="max-w-4xl mx-auto">
                <h1
                  className="text-4xl md:text-5xl font-bold text-center mb-4"
                  style={{ color: "rgb(0, 55, 32)", letterSpacing: "-0.02em" }}
                >
                  Watch Price by Kilogram
                </h1>
                <p
                  className="text-lg text-gray-500 text-center mb-8"
                  style={{ maxWidth: "700px", margin: "0 auto" }}
                >
                  Displaying watch prices based on their weight in kilograms.
                </p>
              </div>
            </section>
      
            {/* Card Section */}
            <section className="w-full flex flex-col items-center justify-center">
              <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                {watchData.map((watch, idx) => (
                  <Card
                    key={watch.name}
                    className="product-card group"
                    style={{
                      background:
                        "linear-gradient(180deg, #ffffff 0%, #f7faf9 100%)",
                      border: "1px solid rgba(0, 0, 0, 0.05)",
                      borderRadius: "16px",
                      padding: "2.5rem 2rem",
                      transition: "all 0.35s ease",
                      cursor: "pointer",
                      boxShadow:
                        "0 5px 15px rgba(0, 0, 0, 0.05), 0 0 10px rgba(0, 55, 32, 0.05)",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: "280px",
                    }}
                    onMouseEnter={e => (e.currentTarget.style.transform = "translateY(-6px)")}
                    onMouseLeave={e => (e.currentTarget.style.transform = "translateY(0)")}
                  >
                    {watch.image ? (
                      <div
                        style={{
                          width: "110px",
                          height: "110px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          marginBottom: "1.5rem",
                          border: "3px solid rgba(0, 55, 32, 0.1)",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                        }}
                      >
                        <img
                          src={watch.image}
                          alt={watch.name}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          onError={e => {
                            e.target.src = "https://via.placeholder.com/100x100?text=No+Image";
                          }}
                        />
                      </div>
                    ) : null}
                    <h3
                      style={{
                        fontWeight: 700,
                        fontSize: "1.25rem",
                        lineHeight: 1.3,
                        marginBottom: "0.75rem",
                        color: "rgb(0, 55, 32)",
                      }}
                    >
                      {watch.name}
                    </h3>
                    <p style={{ fontSize: "0.95rem", color: "rgb(87, 99, 93)", margin: 0, lineHeight: 1.6 }}>
                      Harga per Kg: Rp{watch.pricePerKg.toLocaleString("id-ID")},00
                    </p>
                    <p style={{ fontSize: "0.95rem", color: "rgb(87, 99, 93)", margin: 0, lineHeight: 1.6 }}>
                      Harga Lapak: Rp{watch.priceLapak.toLocaleString("id-ID")},00
                    </p>
                  </Card>
                ))}
              </div>
            </section>
    </div>
  );
};

export default Home;